import * as Sentry from '@sentry/vue'
import App from './App.vue'
import { Integrations } from '@sentry/tracing'
import store from '@/store'
import Vue from 'vue'
import VueRouter from 'vue-router'
import vuetify from './plugins/vuetify'


Vue.use(VueRouter)
Vue.config.productionTip = false

Sentry.init({
    Vue: Vue,
    dsn: 'https://bbfae99806b74f67ad27675bec8d8281@o86855.ingest.sentry.io/1261627',
    // Monitor Performance
    integrations: [new Integrations.BrowserTracing()],
    tracingOptions: {
        trackComponents: true
    }
})

new Vue({
    store,
    vuetify,
    render: h => h(App),
    beforeCreate() {
        this.$store.commit('initializeStore')
        this.$store.dispatch('validateAuth')
    }
}).$mount('#app')
